import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import { FormLabel } from '@/components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const TemplateNameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.name && touched.name}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Name</FormLabel>
                <Field
                    name="name"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter template name"
                            label="Name *"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Shown to admins picking this template from the Auto Attendant builder's Template dropdown."
                        ariaLabel="template-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.name}</FieldError>
        </FormControl>
    );
};

export default TemplateNameField;
